// inv/src/pages/solutions/established-businesses/EstablishedBusinessesPage.jsx
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import SeoHead from '../../../seo/seoHead';
import EstablishedHero from './blocks/EstablishedHero';
import EstablishedDiscoverSection from './blocks/EstablishedDiscoverSection';
import EstablishedResearchSection from './blocks/EstablishedResearchSection';
import SolutionDataExportSection from '../components/SolutionDataExportSection';
import { useInitialData } from '../../../components/data/DataContext';
import languages from '../../../locales/languages';

const EstablishedBusinessesPage = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const ssr = useInitialData() || {};

  const ssrLang = ssr.lang || null;
  const seo = ssr.seo || {};

  const firstSeg = location.pathname.split('/').filter(Boolean)[0];
  const urlLang = languages.some(l => l.code === firstSeg) ? firstSeg : 'en';
  const lng = ssrLang || urlLang || (i18n.language || 'en').split('-')[0];

  const fallbackTitle = t(
    'pageSolutions.EstablishedBusinesses.t1',
    'Find the right investors to scale your established business'
  );
  const fallbackDescription = t(
    'pageSolutions.EstablishedBusinesses.t2',
    'Use Crino to map growth equity, private equity and strategic investors who back businesses at your stage — so you can finance expansion on your terms.'
  );

  const {
    title = fallbackTitle,
    description = fallbackDescription,
    canonicalUrl,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    ogType,
    twitterCard,
    alternates,
    jsonLd,
  } = seo;

  return (
    <>
      <SeoHead
        lang={lng}
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogImage={ogImage}
        ogUrl={ogUrl}
        ogType={ogType}
        twitterCard={twitterCard}
        alternates={alternates}
        jsonLd={jsonLd}
      />

      <div className="mt-8">
        <EstablishedHero />
        <EstablishedDiscoverSection />
        <EstablishedResearchSection />
        <SolutionDataExportSection audience="established" />
      </div>
    </>
  );
};

export default EstablishedBusinessesPage;
